export default __webpack_public_path__ + "static/Tek_Gravity_Grenade-2bbb62140bacfdff9e57df01985f9526.png";